import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { take, takeUntil } from 'rxjs';
import { StudyFile } from 'src/app/models/Study/study-file.model';
import { MediaGroup } from 'src/app/models/media/media-group.model';
import { AuthService } from 'src/app/services/auth.service';
import { ViewMode } from 'src/app/shared-new/enums/view-mode.emun';
import { StudiesFacade } from 'src/app/shared-new/store/studies/studies.facade';
import { ActivityLogModel } from '../../../../models/activity-log/activity-log.model';
import { BaseUnsubscribeComponent } from '../../../../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { ImageModalComponent } from '../image-modal/image-modal.component';
import { FilterActiveGroupPipe } from '../../../../shared-new/pipes/filter-active-group.pipe';

@Component({
  selector: 'app-xray-grid',
  templateUrl: './xray-grid.component.html',
  styleUrls: ['./xray-grid.component.scss'],
})
export class XrayGridComponent extends BaseUnsubscribeComponent implements OnInit {
  public studyFiles: StudyFile[] = [];
  @Input() hideEmptyCategories: boolean = false;
  @Input() isEditable: boolean = false;
  @Input() studyFileIds: number[] = [];
  @Input() viewMode: ViewMode = ViewMode.DRAFT;
  mediaGroupsAll$ = this.studyFacade.mediaGroupsAll$;
  xraysMediaGroups: any;
  mediaCategories$ = this.studyFacade.rawMediaCategories$;
  activityLogId: number = 0;
  isActivtyEnded: boolean = true;
  isSalesCompany = false;
  viewOnly = true;
  
  constructor(
    private studyFacade: StudiesFacade,
    private modalService: NgbModal,
    private authService: AuthService,
    private filterPipe: FilterActiveGroupPipe
  ) {
    super();
    this.isSalesCompany = this.authService.IsSalesCompany();
  }
  ngOnInit() {
    this.studyFacade.studyFiles$.pipe((takeUntil(this.unsubscribe$))).subscribe((response) => {
      if (response) {
        this.studyFiles = this.studyFileIds.length > 0 && this.isEditable
          ? [...response].filter((sf) => this.studyFileIds.includes(sf.studyFileId))
          : [...response];
        this.loadXrays();
      }
    });
  }
  private loadXrays() {
    this.studyFacade.getXraysMediaGroupsByStudyFiles(this.studyFiles).pipe(take(1))
      .subscribe((mediaGroups: any) => {
        this.xraysMediaGroups = mediaGroups;
        setTimeout(() => {
          if (this.isEditable) {
            $('.modal').animate({
              scrollTop: ($('.study-image img:first')?.position()?.top ?? 0) - 100
            }, 600);
          }
        },100)
      });
  }
  trackByGroup(index: number, el: MediaGroup): number {
    return el.id;
  }

  trackByCategory(index: number, el: any): number {
    return el?.category?.id;
  }

  trackByStudyFile(index: number, el: StudyFile): number {
    return el.studyFileId;
  }

 
  get leftGroups() {
    return this.filterPipe.transform(this.xraysMediaGroups.displayMediaGroups, true);
  }

  get rightGroups() {
    return this.filterPipe.transform(this.xraysMediaGroups.displayMediaGroups, false);
  }

  get maxLength() {
    return Math.max(this.leftGroups.length, this.rightGroups.length);
  }
  trackByIndex(index: number): number {
    return index;
  }
  get range() {
    return Array.from({ length: this.maxLength }, (_, i) => i);
  }

  private startActivity(activityId: number, studtFile: StudyFile): void {
    if (this.isActivtyEnded) {
      const activity: ActivityLogModel = {
        activityId: activityId,
        horseId: studtFile.horseId,
        saleId: studtFile.saleId,
        seriesInstanceUID: studtFile.seriesInstanceUID,
        studyInstanceUID: studtFile.studyInstanceUID,
        disclosedClient: null,
        jsonData: null,
        studyFileId: [],
      };
      this.isActivtyEnded = false;
      this.studyFacade.startActivity(activity);
      this.studyFacade.startedActivityLogId$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((activityLogId) => {
          this.activityLogId = activityLogId;
        });
    }
  }
  private endActivity(): void {
    if (!this.isActivtyEnded) {
      this.studyFacade.endActivity(this.activityLogId);
      this.studyFacade.isActivityEnded$
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((response) => (this.isActivtyEnded = response));
    }
  }

  emitChangeMediaCategory(model: {
    studyFile: StudyFile,
    mediaCategoryId: number,
    replacing: boolean,
    extra: boolean
  }): void {
    let isAdditional = model.studyFile.isAdditional;
    this.studyFacade.updateStudyFile(
      model.studyFile.studyFileId,
      model.mediaCategoryId,
      model.replacing,
      model.extra,
      isAdditional,
      model.studyFile.studyId,
      model.studyFile.saleId,
      model.studyFile.horseId
    );
    return;
  }

 

  viewImage(data: { url: string; studyFileId: number }): void {
    if (!this.isSalesCompany) {
      return;
    }

    const studyFile: StudyFile = this.studyFiles.filter(
      (x) => x.studyFileId === data.studyFileId
    )[0];
    //this.startActivity(Activity.XRayView, studyFile);
    const modalRef = this.modalService.open(ImageModalComponent, {
      size: '75-width',
      centered: true,
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.url = data.url;
    modalRef.componentInstance.studyFile = studyFile;
    modalRef.result.then(
      (result) => {
        //this.endActivity();
      },
      (reason) => {
        //this.endActivity();
      }
    );
  }
}
